import * as api from './middleware/api.middleware';
// Interfaces
import {
    IEventRecordDetails,
    IEventRecord,
    IActivityLogRequest,
    IReceivedEventType,
} from '../interfaces/activityLogs.interfaces';

const serviceUrl = '/businesseventlogservice/v1';

export function getActivityLog(searchData: IActivityLogRequest) {
    return api.post<Array<IEventRecord>>(`${serviceUrl}/activity-logs`, searchData);
}

export function getActivityLogDetails(logId: number) {
    return api.get<IEventRecordDetails>(`${serviceUrl}/activity-logs/${logId}/details`);
}

export function getActivityLogEventTypes() {
    return api.get<Array<IReceivedEventType>>(`${serviceUrl}/event-types`);
}
